import React from "react";

export default function Nearby({ PropertyObject }) {
  const nearbyData = React.useMemo(() => {
    const source = Array.isArray(PropertyObject)
      ? PropertyObject
      : Array.isArray(PropertyObject?._lstPropertyNearAmenities)
        ? PropertyObject._lstPropertyNearAmenities
        : [];

    return source.filter((item) => item?.IsActive !== false);
  }, [PropertyObject]);

  const formattedNearby = React.useMemo(() => {
    return nearbyData.map((item, index) => {
      const unit = String(item?.DistanceType || "").toUpperCase() === "K" || String(item?.DistanceType || "").toUpperCase() === "Km" ? "km" : "Meter";
      const distanceValue = item?.Distance ? `${item.Distance} ${unit}` : "-";

      return {
        id: item?.Id ?? index,
        label: item?.AmenitiesName ? `${item.AmenitiesName}:` : `Nearby ${index + 1}:`,
        distance: distanceValue,
        distancetype: item?.DistanceType || "Km"
      };
    });
  }, [nearbyData]);

  const middle = Math.ceil(formattedNearby.length / 2);
  const nearbyLeft = formattedNearby.slice(0, middle);
  const nearbyRight = formattedNearby.slice(middle);

  return (
    <>
      <h5 className="title fw-6">What’s nearby?</h5>
      <p>
        Explore nearby amenities to precisely locate your property and identify
        surrounding conveniences, providing a comprehensive overview of the
        living environment and the property's convenience.
      </p>

      {formattedNearby.length === 0 ? (
        <p>No nearby amenities available.</p>
      ) : (
        <div className="row box-nearby">
          <div className="col-md-5">
            <ul className="box-left">
              {nearbyLeft.map((item) => (
                <li key={item.id} className="item-nearby">
                  <span className="label">{item.label}</span>
                  <span className="fw-7">{item.distance}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-md-5">
            <ul className="box-right">
              {nearbyRight.map((item) => (
                <li key={item.id} className="item-nearby">
                  <span className="label">{item.label}</span>
                  <span className="fw-7">{item.distance}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </>
  );
}
